'use strict';

// ----------------------------------------
// Private
// ----------------------------------------

let $showMore = $('.item__show-more');
let $showMoreWrap = $('.item__description');

// ----------------------------------------
// Public
// ----------------------------------------

function textWrap () {
	if (!$showMoreWrap.length) {
		return false;
	}

	if ($showMoreWrap.outerHeight() > 400) {
		$showMoreWrap.addClass('small');
		$showMore.show();
	}

	$showMore.on('click', function () {
		$showMoreWrap.addClass('show').removeClass('small');
		$(this).hide();
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {textWrap};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/text-wrap.js